var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.352 3H13.751C10.588 3.006 8.02 5.533 8 8.662v33.675c.02 3.13 2.588 5.657 5.75 5.663h25.618a2.654 2.654 0 0 0 1.885-.745c.48-.488.748-1.141.747-1.822V5.62c-.003-1.446-1.187-2.617-2.648-2.62zm-11.36 2.143h6.362v10.05l-2.258-3.563a1.09 1.09 0 0 0-1.857 0l-2.247 3.547V5.143zm-17.799 3.52c.009-1.94 1.596-3.511 3.558-3.52h12.075V16.07c-.041.87.511 1.66 1.348 1.929.953.284 1.809-.327 2.318-1.13l1.684-2.68 1.684 2.68c.503.792 1.359 1.403 2.339 1.13a1.935 1.935 0 0 0 1.348-1.918V5.17h2.821c.25.003.452.202.455.45v31.07a2.667 2.667 0 0 0-.455-.037H13.751a5.758 5.758 0 0 0-3.558 1.227V8.662zm29.63 32.613-24.968.027c-.598 0-1.083.48-1.083 1.072 0 .591.485 1.07 1.083 1.07l24.968-.026v1.993a.453.453 0 0 1-.13.321.464.464 0 0 1-.325.129H13.751c-1.967 0-3.56-1.577-3.56-3.522 0-1.946 1.593-3.523 3.56-3.523h25.617c.25.003.452.203.455.45v2.01z",
    stroke: "#4884E8",
    strokeWidth: 0.4,
    fill: "#4884E8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.b6747e73.svg";
export { ForwardRef as ReactComponent };